export const RegistryStateKeys = {
  in_the_future: 'in_the_future',
  open: 'open',
  in_the_past: 'in_the_past',
}
